export const precision = (num) => {
    return (num.toString().split(".")[1] || []).length;
};
export const isDecimal = (num) => {
    return !isNaN(num) && num % 1 > 0;
};
